// ===================================================================
// KAIXO - ContactPickerModal
// ===================================================================
// Modal para elegir un usuario KAIXO y compartirlo como tarjeta de
// contacto en un chat (1:1 o grupo). Estilo WhatsApp pero con la
// estética KAIXO: paleta naranja, fondo plano, botones con borde gris
// hover naranja. Aislado en su propia carpeta para no interferir.
// ===================================================================

import React, { useState, useMemo } from 'react';
import ReactDOM from 'react-dom';
import { Icons } from '../Icons/Icons';
import useModalClose from '../../hooks/useModalClose';
import './ContactPickerModal.css';

export default function ContactPickerModal({
    allUsers = [],
    currentUser,
    onSelect,
    onClose
}) {
    useModalClose(onClose);
    const [search, setSearch] = useState('');

    // Excluir al user actual (no se comparte a sí mismo) y filtros
    const filtered = useMemo(() => {
        const myId = currentUser?._id?.toString();
        const q = search.trim().toLowerCase();
        return (allUsers || [])
            .filter(u => u && u._id?.toString() !== myId)
            .filter(u => !q || (u.name || '').toLowerCase().includes(q) || (u.handle || '').toLowerCase().includes(q))
            .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
    }, [allUsers, currentUser?._id, search]);

    return ReactDOM.createPortal(
        <div className="cpicker-overlay" onClick={onClose}>
            <div className="cpicker-modal" onClick={e => e.stopPropagation()}>
                <div className="cpicker-header">
                    <h3>Compartir contacto</h3>
                    <button className="cpicker-close" onClick={onClose} aria-label="Cerrar">
                        <Icons.Close size={16} color="white" />
                    </button>
                </div>

                <div className="cpicker-search-wrap">
                    <input
                        className="cpicker-search"
                        type="text"
                        placeholder="Buscar contacto..."
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        autoFocus
                    />
                </div>

                <div className="cpicker-list">
                    {filtered.length === 0 ? (
                        <div className="cpicker-empty">
                            {search ? 'Sin resultados' : 'No hay contactos disponibles'}
                        </div>
                    ) : filtered.map(u => (
                        <button
                            key={u._id}
                            className="cpicker-item"
                            onClick={() => {
                                onSelect({
                                    userId: u._id,
                                    name: u.name || '',
                                    avatar: u.avatar || '',
                                    phone: u.phone || '',
                                    handle: u.handle || '',
                                    language: u.language || ''
                                });
                            }}
                        >
                            <div className="cpicker-avatar">
                                {u.avatar
                                    ? <img src={u.avatar} alt="" />
                                    : <span>{(u.name || '?').charAt(0).toUpperCase()}</span>}
                            </div>
                            <div className="cpicker-info">
                                <div className="cpicker-name">{u.name || '(sin nombre)'}</div>
                                {u.handle && <div className="cpicker-sub">@{u.handle}</div>}
                            </div>
                        </button>
                    ))}
                </div>
            </div>
        </div>,
        document.body
    );
}
